import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { useLocalStorage } from "@uidotdev/usehooks";
import { Link } from "react-router-dom";

const EmpoweringFarmersAndCommunities = () => {
  const [storedName] = useLocalStorage("name", null);
  const { brandData, loading, errors } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName || "[Brand Name]";

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2" style={{ textAlign: "left" }}>
          Empowering Farmers & Communities
        </h2>
      </div>

      {/* Intro Section */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {loading.brand && "Loading brand information..."}
                {!loading.brand && errors.brand && "Error loading brand information."}
                {!loading.brand && !errors.brand && (
                  <>
                    At {brandName}, we place farmers at the center of our mission. Through farmer-operated centers, fair pricing, and instant digital payments, we ensure their efforts are rewarded transparently. By fostering leadership and strengthening rural economies, we're creating opportunities for lasting growth and prosperity.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="wrapper2">
        <br />
        <h6 className="card-title fw-bold my-2 mx-1">Strengthening rural communities with:</h6>
        <div className="underline2 my-3 mx-1"></div>
      </div>

      {/* Community Strengthening Features */}
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-2 g-3">

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Farmer-Operated-Collection-Centers_-min.png" alt="" className="card-img-top" />
                <h6 className="fw-normal" style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}>
                  Farmer-Operated <br />Collection Centers
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Instant-Digital-Payments_-min.png" alt="" className="card-img-top" />
                <h6 className="fw-normal" style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}>
                  Instant Digital<br /> Payments
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Quality-Based-Pricing-Practices_-min.png" alt="" className="card-img-top" />
                <h6 className="fw-normal" style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}>
                  Quality-Based<br /> Pricing Practices
                </h6>
              </div>
            </div>

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Farmer-Learning-and-Skill-Development_-min.png" alt="" className="card-img-top" />
                <h6 className="fw-normal" style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}>
                  Farmer Learning<br /> and Skill Development
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Milk Grading Insights */}
      {/* <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Milk Grading Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <Link to="/technology-driven-quality-tests">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-45.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      Technology-Driven<br /> Quality Checks
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/empowering-farmers-and-communities">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-46.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                      Empowering Farmers & Communities
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/sustainability-in-milk-grading">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-47.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      Sustainability in Milk Grading
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/cloud-connectivity">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-48.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ top: "30%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>Cloud Connectivity</h6>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div> */}

      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Traceability Journey */}
      {/* <div className="wrapper2">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div> */}
      {/* 
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />
            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />
            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />
            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />
            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />
            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName || "You"}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div> */}

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/technology-driven-quality-tests"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/sustainability-in-milk-grading"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>

    </div>
  );
};

export default EmpoweringFarmersAndCommunities;

